import { startOfDay } from "date-fns";

// A finished day barely changes, so its heavy per-day lists outlive RTK's 60 s default.
// Mutations still invalidate them through their tags.
export const PAST_DAY_CACHE_S = 5 * 60;

export const isPastDay = (day: Date, now = new Date()) => day < startOfDay(now);
